/* eslint-disable import/prefer-default-export */
import React from 'react';
import TableFiler from 'components/Filters/Table';
import SupplierListEmptyState from 'assets/img/placeholder/supplier-list-place-holder.svg';
import FactoryListEmptyState from 'assets/img/placeholder/factory-list-place-holder.svg';
import {
  ActionsCell,
  ItemNameCell,
  ProductCategoryCell,
  StatusCell,
  TextCell,
  TagCell,
} from '../../../modules/shared-elements/TableCells';
import RatingCell from '../../../modules/shared-elements/TableCells/RatingCell';
import moment from 'moment';
import uniqBy from 'lodash/uniqBy';
export const getSupplierColDefs = ({ filters, actions, filtered }) => {
  return [
    {
      title: 'Supplier Name / ID / Tag',
      dataIndex: 'name',
      key: 'name',
      width: 'auto',
      render: (_, record) => {
        return (
          <ItemNameCell
            itemTags={record.tags}
            image={record.companyLogo ? record.companyLogo.url : null}
            itemNo={record.supplierId || null}
            itemName={record.name}
          />
        );
      },
    },
    {
      title: 'Location',
      dataIndex: 'country',
      key: 'country',
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
        return (
          <TableFiler.DefaultFilter
            filterSearch
            placeholder='Search location'
            onApply={(selected) => {
              setSelectedKeys([...selected.filter((value) => !!value)]);
              confirm(selected);
            }}
            onReset={() => {
              clearFilters();
            }}
            disablePopover
            options={filters.location}
            selections={selectedKeys || []}
          />
        );
      },
      render: (_, record) => {
        const { area } = record;
        const label = [area?.city, area?.state, area?.country]
          .filter((value) => !!value)
          .join(', ');
        return <TextCell>{label}</TextCell>;
      },
    },
    {
      title: 'Product Category',
      dataIndex: 'productSubCategories',
      key: 'category',
      width: '250',
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
        return (
          <TableFiler.DefaultFilter
            filterSearch
            placeholder='Search product category'
            onApply={(selected) => {
              setSelectedKeys([...selected.filter((value) => !!value)]);
              confirm(selected);
            }}
            onReset={() => {
              clearFilters();
              setSelectedKeys([]);
            }}
            // className={classes['ml-0']}
            disablePopover
            options={filters.productCategory}
            selections={selectedKeys || []}
          />
        );
      },
      render: (value) => {
        let productCategories = [];
        if (value) {
          productCategories = value
            .map(({ productCategory }) => productCategory)
            .map(({ id, name_en }) => ({ id, name: name_en }));
        }
        return <ProductCategoryCell productCategories={uniqBy(productCategories, 'id')} />;
      },
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 88,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
        return (
          <TableFiler.DefaultFilter
            onApply={(selected) => {
              setSelectedKeys([...selected.filter((value) => !!value)]);
              confirm(selected);
            }}
            onReset={() => {
              clearFilters();
            }}
            disablePopover
            options={filters.status}
            selections={selectedKeys || []}
            multiple={false}
          />
        );
      },
      render: (value) => {
        return <StatusCell status={value} />;
      },
    },
    {
      title: 'Rating',
      dataIndex: 'rating',
      key: 'rating',
      width: 76,
      sorter: { direction: 'asc' },
      render: (value, record) => {
        const rating = parseFloat(record?.rating_average || 0);
        return <RatingCell rating={rating.toFixed(2)} />;
      },
    },
    {
      title: 'Last Modified',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      width: 140,
      sorter: { direction: 'asc' },
      render: (value) => {
        const label = value ? moment(value).format('DD/MM/YYYY') : '';
        return <TextCell>{label}</TextCell>;
      },
    },
    {
      title: '',
      dataIndex: 'action',
      key: 'action',
      render: (_, record) => {
        return (
          <ActionsCell
            actions={(actions || []).map((action) => {
              let isActive = record.status == 'active';
              return {
                ...action,
                key: `${record.id}-deactive-supplier`,
                children: `${isActive ? 'Deactive supplier' : 'Active Supplier'}`,
                onClick: () => action.onClick(record),
                danger: isActive,
              };
            })}
          />
        );
      },
    },
  ];
};
export const getFactoryColDefs = ({ filters }) => {
  return [
    {
      title: 'Factory Name / ID',
      dataIndex: 'name',
      key: 'name',
      width: 'auto',
      render: (_, record) => {
        return (
          <ItemNameCell
            itemTags={record.tags}
            image={record.companyLogo ? record.companyLogo.url : null}
            itemNo={record.factoryId}
            itemName={record.name}
          />
        );
      },
    },
    {
      title: 'Location',
      dataIndex: 'country',
      key: 'country',
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
        return (
          <TableFiler.DefaultFilter
            filterSearch
            placeholder='Search location'
            onApply={(selected) => {
              setSelectedKeys([...selected.filter((value) => !!value)]);
              confirm(selected);
            }}
            onReset={() => {
              clearFilters();
            }}
            disablePopover
            options={filters.location}
            selections={selectedKeys || []}
          />
        );
      },
      render: (_, record) => {
        const { area } = record;
        const label = [area?.city, area?.state, area?.country]
          .filter((value) => !!value)
          .join(', ');
        return <TextCell>{label}</TextCell>;
      },
    },
    {
      title: 'Audit Cert',
      dataIndex: 'factoryCertifications',
      key: 'certTypeIds',
      width: 240,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
        return (
          <TableFiler.DefaultFilter
            onApply={(selected) => {
              setSelectedKeys([...selected.filter((value) => !!value)]);
              confirm(selected);
            }}
            onReset={() => {
              clearFilters();
            }}
            disablePopover
            options={filters.auditCert}
            selections={selectedKeys || []}
          />
        );
      },
      render: (value) => {
        let tags = [];
        if (Array.isArray(value)) {
          tags = value
            .filter(({ certificationType }) => !!certificationType)
            .map(({ certificationType }) => certificationType);
        }
        return <TagCell tags={uniqBy(tags, 'id')} />;
      },
    },

    {
      title: 'Last Modified',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      sorter: { direction: 'asc' },
      render: (value) => {
        const label = value ? moment(value).format('DD/MM/YYYY') : '';
        return <TextCell>{label}</TextCell>;
      },
    },
  ];
};

export const EMPTY_STATE = {
  Supplier: {
    image: SupplierListEmptyState,
    title: 'Maintain a seamless connection with supplier',
    subTitle:
      'Effectively manage your massive supplier database for better sourcing decisions and streamline the working process.',
  },
  Factory: {
    image: FactoryListEmptyState,
    title: 'Know better of your supply chain',
    subTitle:
      'Track where your products are made and measure the quality of the factory according to the audit certificates it .',
  },
};

export const MOCK_SUPPLIER_DATA = [
  {
    id: 'ST976',
    tags: [
      { name: '#2021Stationary', id: 123 },
      { name: '#Gift', id: 321 },
    ],
    name: 'Troy Northwestern Stationary Ltd.',
    location: 'Pennsylvania, United States',
    productCategory: [
      { id: '123', name: 'Art, Gifts, Crafts & Needlework' },
      { id: '321', name: 'Office & School Supplies' },
    ],
    status: 'active',
    rating: 4.5,
    // image: null,
    image: 'https://i.pravatar.cc/150',
  },
];
